import { Navigate, Route, Routes } from "react-router-dom";
import Header from "../../components/shared/Header";
import Dashboard from "../../containers/pages/dashboard/Dashboard";
import PasswordReset from "../../containers/pages/profile/Passwordreset";
import Profile from "../../containers/pages/profile/Profile";
import UserBooking from "../../containers/pages/bookings/user/UserBooking";
import Booking from "../../containers/pages/bookings/admin/Booking";
import MessageDetails from "../../containers/pages/messages/MessageDetails";
import FeedDetails from "../../containers/pages/feeds/FeedDetails";
import KPI from "../../containers/pages/kpi/KPI";
import Project from "../../containers/pages/projects/Project";
import ProjectDetails from "../../containers/pages/projects/ProjectDetails";
import { useSelector } from "react-redux";
import {
  canEditModule,
  canViewModule,
  getModulePermissions,
  isBookingAdmin,
} from "../../utils/moduleAccess";

export function Developer({ usersession }) {
  const authState = useSelector((state) => state.auth);
  const modulePermissions = getModulePermissions(authState);
  const isBookingAdminUser = isBookingAdmin(authState);

  const canViewProject = canViewModule(modulePermissions, "project");
  const canViewBooking = canViewModule(modulePermissions, "booking");
  const canEditBooking = canEditModule(modulePermissions, "booking") && isBookingAdminUser;

  return (
    <div className="App">
      <Header isDeveloper={true} />
      <div className="mt-1.5 lg:mt-2.5">
        <Routes>
          <Route path="/dashboard" element={<Navigate to="/" replace />} />
          <Route
            path="/projects"
            element={canViewProject ? <Project isDeveloper={true} /> : <Navigate to="/" replace />}
          />
          <Route path="/availability" element={<Navigate to="/" replace />} />
          <Route path="/people" element={<Navigate to="/" replace />} />
          <Route
            path="/projects/:name/:status"
            element={canViewProject ? <ProjectDetails isDeveloper={true} /> : <Navigate to="/" replace />}
          />
          <Route
            path="/bookings"
            element={canViewBooking ? (canEditBooking ? <Booking /> : <UserBooking />) : <Navigate to="/" replace />}
          />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<PasswordReset />} />
          <Route path="/notifications/messages/:id" element={<MessageDetails />} />
          <Route path="/feeds/:id" element={<FeedDetails />} />
          <Route path="/kpi/*" element={<KPI isDeveloper={true} />} />
          <Route path="/" element={<Dashboard />} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </div>
    </div>
  );
}
